import React from 'react'
import { Select } from './Select'

const booleanOptions = [
  { text: "True", value: 1 },
  { text: "False", value: 0 },
];

type SelectBooleanProps = {
  col: number
  name: string
  labelCol: number
  labelText: string
    setFieldValueOf?: (e: React.ChangeEvent<any>, setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void) => void
}

export const SelectBoolean: React.FC<SelectBooleanProps> = ({col, name, labelCol, labelText, setFieldValueOf}) => {
  return (
    <Select
      label={{ col: labelCol, text: labelText }}
      col={col}
      name={name}
      options={booleanOptions}
      setFieldValueOf={setFieldValueOf}
    />
  )
}
